export const API_URL = 'https://studio.slideslive.com/api/web_recorder/v3';
export const AUDIO_TEST_LENGTH_IN_S = 5;
export const RECORDING_COUNTDOWN_S = 3;
export const RECORDING_INTERRUPT_AFTER_S = 10;
export const INACTIVITY_REFETCH_MS = 3 * 60 * 60 * 1000;
export const DELETED_VIDEO_STEP = 250;
